export default "__VITE_ASSET__Ci6MHbH1__"